


















import Vue from 'vue';

export default /*#__PURE__*/Vue.extend({
    name: 'glDialog', // vue component name
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        showClose: {
            type: Boolean,
            required: false,
            default: true,
        },
        title: {
            type: String,
            required: false,
        },
        width: {
            type: String,
            required: false,
            default: '41%',
        },
        height: {
            type: String,
            required: false,
            default: '80%',
        },
        clickOutside: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        showVal: {
            get(this: any) {
                return this.value;
            },

            set(this:any, val:any) {
                this.$emit('input', val);
            },
        },
    },
});
